export const PROFILE_READONLY = [
  ["Email", "Email (login)"],
  ["Phone", "Phone"],
];

export const PROFILE_EDITABLE = [
  ["First_Name", "First name"],
  ["Last_Name", "Last name"],
  ["Alt_Phone", "Alternate phone"],
];

export const PROFILE_ADDRESS_EDITABLE = [
  ["Address_Line_1", "Address line 1"],
  ["Address_Line_2", "Address line 2"],
];

export const PROFILE_ADDRESS = [
  ["Address_Line_1", "Address line 1"],
  ["Address_Line_2", "Address line 2"],
  ["Country_Name", "Country"],
  ["State_Name", "State"],
  ["City_Name", "City"],
  ["Zip_Code", "Zip code"],
];

export function displayProfileValue(value) {
  if (value == null || String(value).trim() === "") return "—";
  return String(value);
}
